<p-toast></p-toast>
<p-confirmDialog [style]="{minWidth: '40vw'}" position="top" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="grid">
    <div class="col-12">
        <div class="card">
			<h5>Gestion de Cobros</h5>
            <hr>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="ejecutar()">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-3">
                        <label htmlFor="fecha_desde">Fecha Desde</label>
                        <p-calendar id="fecha_desde" formControlName="fecha_desde" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="fecha_hasta">Fecha Hasta</label>
                        <p-calendar id="fecha_hasta" formControlName="fecha_hasta" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="usuarios">Usuarios:</label>
                        <p-multiSelect
                            [options]="usuarios"
                            optionLabel="nombre"
                            optionValue="nombre"
                            display="nombre"
                            formControlName="usuarios"
                            placeholder="Seleccione los usuarios"
                            [showToggleAll]="true"
                            display="chip"
                        ></p-multiSelect>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-2">
                        <button pButton pRipple type="submit" label="Ejecutar" icon="pi pi-check" class="p-button-info mr-2" pTooltip="Ejecutar"></button>
                    </div>
                    <ng-container *ngIf="items?.length">
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-warning" label="Imprimir" icon="pi pi-print" (click)="descargar()"></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-success" label="Descargar" icon="pi pi-file-excel" (click)="descargarExcel()"></button>
                        </div>
                    </ng-container>
                </div>
            </form>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines" [value]="items" [loading]="loading" dataKey="id" responsiveLayout="scroll" rowHover="true"
            [showCurrentPageReport]="true" [paginator]="true" [rows]="20" currentPageReportTemplate="Mostrando {first} a {last} de {{items.length}} entradas">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="cabecera-detalle align-center" pSortableColumn="nro_actividad">Nro. Actividad<p-sortIcon field="nro_actividad"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="nombre_entidad">Nombre Entidad<p-sortIcon field="nombre_entidad"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="agrupacion">Agrupacion<p-sortIcon field="agrupacion"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="nro_documento">Nro Documento<p-sortIcon field="nro_documento"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="nombre_cliente">Nombre Cliente<p-sortIcon field="nombre_cliente"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="nro_operacion">Nro Operacion<p-sortIcon field="nro_operacion"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="fecha_gestion">Fecha Gestion<p-sortIcon field="fecha_gestion"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="nom_usuario" >Nombre Usuario<p-sortIcon field="nom_usuario"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="fecha_promesa_pago">Fecha Promesa de Pago<p-sortIcon field="fecha_promesa_pago"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="observaciones">Observaciones<p-sortIcon field="observaciones"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="agendar_pago">Agendar Pago<p-sortIcon field="agendar_pago"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="generar_act_nota">Generar Act Nota<p-sortIcon field="generar_act_nota"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="confirmacion_compromiso">Confirmacion Compromiso<p-sortIcon field="confirmacion_compromiso"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="reagendar_llamada" >Reagendar Llamada<p-sortIcon field="reagendar_llamada"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="confirmacion_cobro">Confirmacion Cobro<p-sortIcon field="confirmacion_cobro"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item >
                    <tr class="p-0 m-0">
                        <td class="align-center">{{ item.nro_actividad }}</td>
                        <td class="align-start">{{ item.nombre_entidad }}</td>
                        <td class="align-start">{{ item.agrupacion }}</td>
                        <td class="align-center">{{ item.nro_documento }}</td>
                        <td class="align-start">{{ item.nombre_cliente }}</td>
                        <td class="align-monto">{{ item.nro_operacion }}</td>
                        <td class="align-center">{{ item.fecha_gestion | date: 'dd/MM/yyyy' }}</td>
                        <td class="align-start">{{ item.nom_usuario }}</td>
                        <td class="align-center">{{ item.fecha_promesa_pago | date: 'dd/MM/yyyy' }}</td>
                        <td class="align-start">{{ item.observaciones }}</td>
                        <td class="align-center">{{ traducirCondicion( item.agendar_pago ) }}</td>
                        <td class="align-center">{{ traducirCondicion( item.generar_act_nota ) }}</td>
                        <td class="align-center">{{ traducirCondicion( item.confirmacion_compromiso ) }}</td>
                        <td class="align-center">{{ traducirCondicion( item.reagendar_llamada ) }}</td>
                        <td class="align-center">{{ traducirCondicion( item.confirmacion_cobro ) }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
(close)="cerrarOnLista($event)">
</app-on-lista>



